<template>
  <div>
    <Toast :style="{ width: $isMobile() ? '85vw' : '' }" />
    <Dialog
      :visible="showForm"
      :modal="true"
      :header="'Criar Ordem de Serviço'"
      :style="{ width: $isMobile() ? '100vw' : '40vw' }"
      @hide="cancel"
    >
      <form @submit.prevent="save" ref="form">
        <div class="p-fluid p-formgrid p-grid p-mt-3" style="min-height: 20vh">
          <div class="p-field p-col-12 p-md-12" v-if="!prefillPatId">
            <span class="p-float-label">
              <Dropdown
                id="pat"
                v-model="pat"
                name="pat"
                v-validate="'required'"
                :class="{ 'p-invalid': errors.has('pat') }"
                :options="pats_list"
                :optionLabel="getPatLabel"
                optionValue="id"
                class="p-dropdown-sm"
                appendTo="body"
                :filter="true"
              >
              </Dropdown>
              <label for="pat">PAT</label>
            </span>
            <span v-if="errors.has('pat')" class="p-error" role="alert">
              Pat é obrigatório
            </span>
          </div>
          <div class="p-field p-col-12 p-md-12" v-else>
            <label class="p-ml-2"><strong>PAT:</strong> {{ prefillPatId }}</label>
          </div>
          <div class="p-field p-col-12 p-md-6 p-mt-3">
            <span class="p-float-label">
              <inputText
                id="model_code"
                v-model="model_code"
                name="model_code"
                :class="{ 'p-invalid': errors.has('model_code') }"
                :options="service_types_list"
                class="p-dropdown-sm"
                appendTo="body"
                :filter="true"
              />
              <label for="model_code">Código do Modelo</label>
            </span>
            <span v-if="errors.has('service_type')" class="p-error">
              Código do Modelo é obrigatório
            </span>
          </div>
          <div class="p-field p-col-12 p-md-6 p-mt-3">
            <span class="p-float-label">
              <Dropdown
                id="service_type"
                v-model="service_type_code"
                name="service_type"
                v-validate="'required'"
                :class="{ 'p-invalid': errors.has('service_type') }"
                :options="service_types_list"
                optionLabel="description"
                optionValue="code"
                class="p-dropdown-sm"
                appendTo="body"
                :filter="true"
              />
              <label for="service_type">Tipo de Serviço</label>
            </span>
            <span v-if="errors.has('service_type')" class="p-error">
              Tipo de Serviço é obrigatório
            </span>
          </div>
          <div class="p-field p-col-12 p-md-6 p-mt-3">
            <span class="p-float-label">
              <Dropdown
                id="receipt_type"
                v-model="receipt_type_code"
                name="receipt_type"
                v-validate="'required'"
                :class="{ 'p-invalid': errors.has('receipt_type') }"
                :options="receipt_types_list"
                optionLabel="description"
                optionValue="code"
                class="p-dropdown-sm"
                appendTo="body"
                :filter="true"
              />
              <label for="receipt_type">Tipo de Recibo</label>
            </span>
            <span v-if="errors.has('receipt_type')" class="p-error">
              Tipo de Recibo é obrigatório
            </span>
          </div>
          <div class="p-field p-col-12 p-md-6 p-mt-3">
            <span class="p-float-label">
              <Dropdown
                id="service_product"
                v-model="service_product_code"
                name="service_product"
                v-validate="'required'"
                :class="{ 'p-invalid': errors.has('service_product') }"
                :options="service_product_list"
                optionLabel="description"
                optionValue="code"
                class="p-dropdown-sm"
                appendTo="body"
                :filter="true"
              />
              <label for="service_product">Tipo de Produto</label>
            </span>
            <span
              v-if="errors.has('service_product')"
              class="p-error"
              role="alert"
            >
              Tipo de Produto é obrigatório
            </span>
          </div>
          <div class="p-field p-col-12 p-md-6 p-mt-3">
            <span class="p-float-label">
              <Dropdown
                id="warranty_flag"
                v-model="warranty_flag"
                name="warranty_flag"
                v-validate="'required'"
                :class="{ 'p-invalid': errors.has('warranty_flag') }"
                :options="warranty_flag_list"
                optionLabel="description"
                optionValue="code"
                class="p-dropdown-sm"
                appendTo="body"
                :filter="true"
              />
              <label for="warranty_flag">Tipo de Garantia</label>
            </span>
            <span v-if="errors.has('warranty_flag')" class="p-error">
              Tipo de Garantia é obrigatório
            </span>
          </div>
        </div>
      </form>
      <template #footer>
        <Button
          :label="'Guardar'"
          icon="pi pi-save"
          class="p-button-success"
          @click="save"
        />
        <Button
          label="Cancelar"
          icon="pi pi-times"
          class="p-button-danger"
          @click="cancel"
        />
      </template>
    </Dialog>
  </div>
</template>
<script>
import serviceOrdersService from "../../services/serviceOrders.service";
import patService from "../../services/pat.service";
export default {
  name: "LgCreateFromPat",
  props: ["showForm", "prefillPatId", "prefillModelCode"],
  watch: {
    showForm(value) {
      if (value === true) {
        this.reset();
        this.$validator.resume();
      }
    },
  },
  data() {
    return {
      loading: false,
      service_type_code: null,
      receipt_type_code: null,
      service_product_code: null,
      model_code: null,
      warranty_flag: null,
      pat: null,
      service_types_list: [],
      receipt_types_list: [],
      service_product_list: [],
      warranty_flag_list: [],
      pats_list: [],
    };
  },
  async created() {
    this.service_types_list = await serviceOrdersService.getServiceOrderCodes("service_type");
    this.receipt_types_list = await serviceOrdersService.getServiceOrderCodes("receipt_type");
    this.service_product_list = await serviceOrdersService.getServiceOrderCodes("service_product");
    this.warranty_flag_list = await serviceOrdersService.getServiceOrderCodes("warranty_flag");

    if (!this.prefillPatId) {
      this.pats_list = await patService.getBrandPats("LG");
    }

    this.reset();
  },
  methods: {
    getPatLabel(info) {
      return `PAT ${info.id} | ${info.nome} | ${info.equipment_serie}`;
    },
    save() {
      this.$validator.validateAll().then((isValid) => {
        if (!isValid) {
          this.loading = false;
          return;
        }
        this.$validator.pause();
        let params = {
          service_type_code: this.service_type_code,
          receipt_type_code: this.receipt_type_code,
          service_product_code: this.service_product_code,
          warranty_flag: this.warranty_flag,
          model_code: this.model_code,
        };
        serviceOrdersService
          .createServiceOrderFromPat(this.pat, params)
          .then((response) => {
            if (typeof response === "string") {
              return this.$toast.add({
                severity: "error",
                summary: `Erro ao Alterar ao criar a Ordem de Serviço`,
                detail: response,
                life: 3000,
              });
            }
            this.$toast.add({
              severity: "success",
              summary: `Ordem de Serviço criada com sucesso`,
              detail: "",
              life: 3000,
            });
            return this.$emit("serviceOrderCreated", {
              serviceOrder: response,
            });
          });
      });
    },
    cancel() {
      this.$validator.pause();
      this.reset();
      return this.$emit("cancel");
    },
    reset() {
      this.loading = false;
      this.service_type_code = null;
      this.receipt_type_code = null;
      this.service_product_code = null;
      this.warranty_flag = null;
      this.pat = this.prefillPatId || null;
      this.model_code = this.prefillModelCode || null;

      this.service_type_code = this.service_types_list.length > 0 && this.service_types_list.map(e => e.code).includes('IH') ? 'IH' : null;
      this.receipt_type_code = this.receipt_types_list.length > 0 && this.receipt_types_list.map(e => e.code).includes('SR') ? 'SR' : null;
      this.warranty_flag = this.warranty_flag_list.length > 0 && this.warranty_flag_list.map(e => e.code).includes('IW') ? 'IW' : null;
    },
  },
};
</script>
<style>
.container {
  display: flex;
  flex-direction: column;
  height: 100%;
}
</style>
